export function Dot(props: { colour: string }) {
    return (
        <div
            style={{
                backgroundColor: props.colour,
                marginRight: '8px',
                height: '16px',
                width: '16px',
                borderRadius: '50%',
                display: 'inline-block',
            }}
        />
    );
}
